// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginInput_loginContainer__03DFA","phoneInputWrapper":"LoginInput_phoneInputWrapper__0ozqN","label":"LoginInput_label__n3V7q"};